import { Accordion, AccordionItem, Box, Text } from 'braid-design-system';

import { FILTER_COLLAPSED_SUMMARY_MAX_DISPLAY_COUNT } from '../constants';
import type { Suggestion } from '../types';

interface Props {
  id: string;
  expanded: boolean;
  label: string;
  children: React.ReactNode;
  selectedItems: Suggestion[];
  onToggle: (expanded: boolean) => void;
  collapsedSummary?: string;
}

export const FilterAccordion = ({
  id,
  expanded,
  label,
  children,
  selectedItems,
  onToggle,
  collapsedSummary,
}: Props) => {
  const getDefaultCollapsedSummary = () => {
    const remainingCount =
      selectedItems.length - FILTER_COLLAPSED_SUMMARY_MAX_DISPLAY_COUNT;

    const maxSelectedItemsString = selectedItems
      .slice(0, FILTER_COLLAPSED_SUMMARY_MAX_DISPLAY_COUNT)
      .map((item) => item.name)
      .join(', ');

    return remainingCount > 0
      ? `${maxSelectedItemsString} +${remainingCount}`
      : maxSelectedItemsString;
  };

  const renderCollapsedSummary = () => (
    <Box>
      <Text size="small" tone="secondary">
        {collapsedSummary ?? getDefaultCollapsedSummary()}
      </Text>
    </Box>
  );

  return (
    <Accordion dividers={false} size="small">
      <AccordionItem
        id={id}
        label={label}
        expanded={expanded}
        onToggle={onToggle}
      >
        <Box marginTop="xsmall">{children}</Box>
      </AccordionItem>

      {!expanded && selectedItems.length > 0 && renderCollapsedSummary()}
    </Accordion>
  );
};
